module.exports = __webpack_public_path__ + "img/1696322072938-WhatsApp Image 2023-10-02 at 12.09.37.jpeg.9c10b858.webp";